import { BaseDto } from '../base.dto';

export class PurchaseOrderEdiLogDto extends BaseDto {
  purchaseOrderId: number;
  createdDate?: Date;
  message: {
    errorMessage?: string;
    uploadSuccess?: boolean;
    uploadedFilename?: string;
    connection?: {
      details: {
        data: {
          userName: string;
        };
      };
    };
  };
}
